import { Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";

const Dates = ({ saveDate, publishDate }) => {
  const { t } = useTranslation(["merchandising"]);
  return (
    <>
      {saveDate && (
        <Row className="fs-4">
          <Col xs={12}>
            <div className="fs-4" style={{ fontWeight: "bold" }}>
              {t(($) => $.merchandising["Saved Date"])}
            </div>
          </Col>
          <Col xs={12} className="pb-2">
            {saveDate}
          </Col>
        </Row>
      )}

      {publishDate && (
        <Row className="fs-4">
          <Col xs={12}>
            <div className="fs-4" style={{ fontWeight: "bold " }}>
              {t(($) => $.merchandising["Publish Date"])}
            </div>
          </Col>
          <Col xs={12} className="pb-2">
            {publishDate}
          </Col>
        </Row>
      )}
    </>
  );
};

export default Dates;
